import { Route, Routes } from 'react-router-dom'
import { Toaster } from 'sonner'

import { EnrollPage } from './EnrollPage.js'
import { EventClaimPage } from './EventClaimPage.js'
import './enrollTokens.css'

/**
 * Public customer-facing enrollment surface (slice 4a-4b). Mounted at `/e/*`
 * by the top-level router. Unauthenticated — opens against
 * `GET/POST /api/public/enroll/:branch_slug`. Branded by the tenant's logo,
 * neutral baseline otherwise.
 */
export function EnrollApp() {
  return (
    <div className="enroll-root">
      <Routes>
        {/* Static "events/:code" ranks above the dynamic ":branchSlug". */}
        <Route path="events/:code" element={<EventClaimPage />} />
        <Route path=":branchSlug" element={<EnrollPage />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </div>
  )
}
